import React, { useEffect } from 'react';
import { Wrapper, Background } from './styles';

import { useAuth } from '../../../hooks/Auth';
import { useConfiguration } from '../../../hooks/Configuration';
import { loadFromJson } from '../../../utils/loadFromJson';
import { hash } from '../../../config';
import api from '../../../services/api';
import { useParams } from 'react-router-dom';

const PageLayout: React.FC = ({ children }) => {
  const { token, user } = useAuth();
  const { setConfiguration } = useConfiguration();
  const { handleApiErrors } = useAuth();

  const { projectHash, eventHash } = useParams<Record<string, any>>();


  const load = async (projectHashValue) => {
    // setLoading(true);

    try {


      let data: Record<string, any> = {};

      const project = await loadFromJson({ hash: hash, project_id: projectHashValue, table: 'Project' });

      if (project?.[0]) {
        data = project[0];

        const event = await loadFromJson({ hash: hash, project_id: data.url, table: 'Event' });
        if (event?.[0]) {


          data.current_event_id_response = { ...event[0] };
        }
        else {

          const response = await api.get(eventHash ? `/get-project-content/${projectHashValue}/${eventHash}` : `/get-project-content/${projectHashValue}`);
          data = response?.data;
        }
      }
      else {

        const response = await api.get(eventHash ? `/get-project-content/${projectHashValue}/${eventHash}` : `/get-project-content/${projectHashValue}`);

        data = response?.data;
      }



      setConfiguration(data);




    }
    catch (err) {

      handleApiErrors(err);

    }
  }



  const loadConfig = async () => {
    let data: Record<string, any> = {};

    const item = await loadFromJson({ hash: hash, project_id: 'global', table: 'Global' })


    if (!item) {
      const config = await api.get('/get_platform');

      data = config.data;
    }
    else {
      data = item?.[0] || {}
    }


    if (data?.default_project && !projectHash) {
      load(data?.default_project)
    }
    else {
      load(projectHash);
    }

  }

  useEffect(() => {
    loadConfig();


  }, [projectHash])



  return <Wrapper>{children}</Wrapper>;
};

export default PageLayout;
